/* eslint-disable no-unused-vars */
import {
  FetchArgs,
  createApi,
  fetchBaseQuery,
  retry
} from '@reduxjs/toolkit/query/react';
import { RootState } from '../store';
import { toggleSessionExpired } from '../store/ui';

// Create our baseQuery instance
const baseQuery = fetchBaseQuery({
  // baseUrl: 'http://localhost:8080/',
  baseUrl: 'https://tomcat.cybexai-server.com/',
  prepareHeaders: (headers, { endpoint, getState }) => {
    // By default, if we have a token in the store, let's use that for authenticated requests
    const token = (getState() as RootState)?.auth.token;
    if (token) {
      headers.set('Authorization', `Bearer ${token}`);
    }
    return headers;
  }
});

// old const baseQueryWithRetry = retry(baseQuery , {maxRetries:1})

const baseQueryWithRetry = retry(
  async (args: string | FetchArgs, api, extraOptions) => {
    const result = await baseQuery(args, api, extraOptions);
    // check if token expired
    if (result?.error?.status === 401) {
      // console.log('token expired');
      api.dispatch(toggleSessionExpired(true));
    }

    return result;
  },
  { maxRetries: 0 }
);

const api = createApi({
  reducerPath: 'Api',
  baseQuery: baseQueryWithRetry,
  endpoints: () => ({})
});

export default api;
